import {BenjiKIVOverlayScatterRunner} from "./BenjiKIVOverlayScatterRunner";
import {BenjiKIV} from "../../BenjiKIV";
import {BenjiKIVGameMode} from "../../server/BenjiKIVGameMode";
import {SimplePresentationRunnerController} from "../../../core/winpresentation/SimplePresentationRunner";

/**
 * Created by Jerker Nord on 2022-12-21.
 */

export class BenjiKIVBoostedOverlayScatterRunner extends BenjiKIVOverlayScatterRunner{

    constructor() {
        super();
    }

    public shouldRun():boolean {
        return this.run;
    }

    public start(controller:SimplePresentationRunnerController):void {
        super.start(controller);
    }

    protected onComplete():void {
        BenjiKIV.normalResult.scatterResultRunner.randomOverlayAnimationComplete = true;
    }
}